import { Component, HostBinding, ViewChild, ViewContainerRef } from '@angular/core'
import { CtrlBaseComponent } from '..';
import { FormType } from '../../enums/formType.enum';
import { PfComponents } from '../../enums/pfComponents';

@Component({
  selector: 'ct-row',
  templateUrl: './ct-row.component.html',
  styleUrls: ['./ct-row.component.css'],
  host: { 
    '[id]': 'getId()',
    '[hidden]': 'getHidden()'
   }
})
export class CtRowComponent extends CtrlBaseComponent {
  @ViewChild('target', { read: ViewContainerRef }) target: ViewContainerRef;
  @ViewChild('row', { read: ViewContainerRef }) row: ViewContainerRef;

  private title : string;
  private type : FormType;
  private isDivided : boolean;
  private isFirstRow : boolean;
  private isLastRow : boolean;
  private isDividedTop : boolean;
  private size : number = 100;
  private showBorders : boolean = true;
  public rowId : string;

  constructor() {
    super();
  }
  
  ngAfterViewInit() {
    this.setSummaryColumns();
    this.paintChildren(this.getMetaData(), this.target);
    this.rowId = this.getId()+'_internal_row';
  }

  public getTypeStyle(): string {
    if(this.showBorders == true){
      switch(this.getType()){
        case FormType.Summary:
          return 'summary-row';
      default: 
      return '';
    }
  } 
  }


  private setSummaryColumns(): void {
    if(!(this.type === FormType.Summary)) return;
    
    const columnsCount : number = this.getMetaData().models.map((model) => {
      if(model.ctType === PfComponents.CtColumn) return model;
    }).length;

    this.getMetaData().models.forEach(( model : any, index : number) => {
      if(model.ctType === PfComponents.CtColumn) {
        model.controlProperties['colCount'] = columnsCount
        model.controlProperties['currentCol'] = index+1;
        model.controlProperties['styleClass'] = 'pe-0';
      }
    });
  }

 
  getTitle() { return this.title; }
  getType() : FormType { return this.type }
  getIsDivided(): boolean { return this.isDivided }
  getIsFirstRow(): boolean { return this.isFirstRow }
  getIsLastRow() : boolean { return this.isLastRow}
  getIsDividedTop() : boolean { return this.isDividedTop }
  getSize(): number { return this.size }
  getIsSummaryType() { return this.type === FormType.Summary }
  getShowBorders(): boolean { return this.showBorders }


  setTitle(title: string) {  this.title = title; }
  setType(type : FormType): void { this.type = type}
  setIsDivided(isDivided : boolean): void { this.isDivided = isDivided }
  setIsDividedTop(isDividedTop : boolean): void { this.isDividedTop = isDividedTop }
  setIsFirstRow(isFirstRow : boolean): void { this.isFirstRow = isFirstRow }
  setIsLastRow(isLastRow : boolean): void { this.isLastRow = isLastRow }
  setSize(size : number): void { this.size = size }
  setShowBorders(showBorders: boolean): void { this.showBorders = showBorders }

}